"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DURATION = exports.DEFAULT_HIGHLIGHT_COLOR = exports.DEFAULT_BONE_COLOR = void 0;
exports.DEFAULT_BONE_COLOR = "#121212";
exports.DEFAULT_HIGHLIGHT_COLOR = "#333333";
exports.DEFAULT_DURATION = 500;
//# sourceMappingURL=Constants.js.map